import React, {useState, Fragment, useEffect} from 'react';
import { Card, CardContent } from '@mui/material';
import {useDispatch} from 'react-redux';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import {obtenerRegistrosPersonalizadoPublic } from 'store/actions/customAction';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import { TablaPersonalizada } from 'components';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import { functions } from 'constantes';

const DetalleDeLaCobertura = ({ datosGeneralesDelTarifario}) => {
    const dispatch = useDispatch();

    const [responseData, setResponseData] = useState({ errorType: 'error', messageType: '', openResponse: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
    const [catalogoDeMediosPublicos] = useState("catalogoDeMediosPublicos");
    const [listadoDeCoberturas, setListadoDeCoberturas] = useState([]);

    const [encabezadoTabla] = useState([{ title: 'Departamento', field: 'nombreDepartamento'}, { title: 'Municipio', field: 'nombreMunicipio'}]);

    useEffect( () => { obtenerCoberturas() }, [])

  const obtenerCoberturas = async () => {

    setcargandoSolicitud(true);
    ServiciosDelAPI[catalogoDeMediosPublicos].setearMetodoPublico(true);
    let respuesta = await dispatch(obtenerRegistrosPersonalizadoPublic({
        controller: catalogoDeMediosPublicos,
        saveInStore: false,
        nombreDelMetodo: `listar/coberturaDelMedio/${datosGeneralesDelTarifario.id}` ,
    }));

    setcargandoSolicitud(false);
    if(respuesta?.error) return changeDataResponse('error', respuesta?.error?.message || 'No se pudó obtener los datos', true, );
    if(respuesta?.data?.length === 0) return changeDataResponse('error', respuesta?.error?.message || 'No existen datos para este medio', true, );
    if(!respuesta?.data) return changeDataResponse('error', respuesta?.error?.message || 'No existen datos para este medio', true, );

    const coberturasOrdenadas = functions.ordenarArreglo(respuesta?.data, 'departamento_id')
    setListadoDeCoberturas(coberturasOrdenadas)
  }

  const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (errorType, messageType, openResponse = false) => setResponseData({errorType,messageType,openResponse,});

    const { errorType, messageType, openResponse} = responseData;

    return (
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={errorType} content={messageType} open={openResponse} handClose={handClose}/>
            <Card>
                <CardContent>
                  <TablaPersonalizada
                        data={listadoDeCoberturas}
                        title={"Listado de coberturas"}
                        header={encabezadoTabla}
                        addRegister={undefined}
                    />
                </CardContent>
            </Card>
        </Fragment>
    );
}

export default DetalleDeLaCobertura;